import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeatSIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.0667 2H2.93333C2.41787 2 2 2.41787 2 2.93333V15.0667C2 15.5821 2.41787 16 2.93333 16H15.0667C15.5821 16 16 15.5821 16 15.0667V2.93333C16 2.41787 15.5821 2 15.0667 2Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11 5.5H9C8.46957 5.5 7.96086 5.6475 7.58579 5.91005C7.21071 6.1726 7 6.5287 7 6.9C7 9 11 9 11 11.1C11 11.4713 10.7893 11.8274 10.4142 12.0899C10.0391 12.3525 9.53043 12.5 9 12.5H7",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBeatSIcon;
